import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const filesList: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  alignItems: 'center',
  flexWrap: 'wrap',
  '&.uploadedFiles': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 3,
  },

  '.file__icon': {
    flexShrink: 0,
  },

  /* PREPEND HERE */
};
